var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mb-1" }, [
        _vm.hasLabel
          ? _c("div", { class: _vm.labelClass }, [
              _c(
                "label",
                {
                  staticClass: "dmv-text dmv-text-primary",
                  attrs: { for: _vm.controlId }
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(_vm.label) + "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { class: _vm.controlClass }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newValue,
                expression: "newValue"
              }
            ],
            staticClass: "form-control text-control",
            attrs: {
              id: _vm.controlId,
              name: _vm.controlId,
              type: "text",
              placeholder: _vm.placeholder,
              disabled: !_vm.isEnabled
            },
            domProps: { value: _vm.newValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newValue = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }